<template>
  <div v-if="!isLoading">
    <div>
      <div class="row mx-0 mt-2 mb-3 justify-content-between">
        <div class="main-color-text bold-text"> {{ $t('operation.bilan.Assurances').toUpperCase() }}</div>
        <div class="row mx-0 align-items-center">
          <div class="row mx-0 align-items-center">
            <b-link class="main-color-text bold-text ml-3" v-on:click="clickOnEditBtn()">
              {{ $t('Modify') }}
              <pencil-icon size="18"/>
            </b-link>
          </div>
        </div>
      </div>
      <div>{{$t('operation.acteAchat.info.tab',{0 : "assurances", 1: acteAchat ? new Date(acteAchat).toLocaleDateString() : 'N/A'})}}</div>
      <b-table id="table-construction" ref="table"
               :fields="tableFieldsInsurances"
               :items="itemsInsurances"
               :tbody-tr-class="rowClass"
               :thead-class="'row-header'"
               borderless
               class="light-border"
               striped>
        <template #cell(type)="data">
          {{ $t(data.value) }}
        </template>
        <template #cell(HT)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
        <template #cell(TVA)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
        <template #cell(TTC)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>

import api from "../../../services/api";

export default {
  name: "OperationShowInsurances",

  components: {},

  props: {
    operationId: {
      default: null
    },
    operationBilanId: {
      default: null
    },
    simulationId: {
      default: null
    },
    acteAchat: {
      default: null
    }
  },

  data() {
    return {
      isLoading: false,
      tableFieldsInsurances: [
        {label: '', key: 'type'},
        {label: 'HT', key: 'HT', thStyle: {width: "15%"}},
        {label: 'TVA', key: 'TVA', thStyle: {width: "15%"}},
        {label: 'TTC', key: 'TTC', thStyle: {width: "15%"}},
      ],
      itemsInsurances: [],
    }
  },

  async mounted() {
    await this.fetchData()
  },

  methods: {

    async fetchData() {
      await this.getInsurancesData()
    },

    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.status === 'title-section-margin') return 'row-title-section row-margin'
      if (item.status === 'title-section') return 'row-title-section'
      else if (item.status === 'total-primary') return 'row-total-primary'
      else if (item.status === 'total-grey') return 'row-total-grey'
      else if (item.status === 'subtitle') return 'bold-text main-red-color'
    },

    async getInsurancesData() {
      this.isLoading = true
      api
        .get(`/operationBilan/getInsurancesData/${this.operationId}`)
        .then(response => {
          this.itemsInsurances = response.data['itemsInsurances']
          this.isLoading = false
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
            })
          }
        })
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'OperationBilanInsurancesEdit',
        params: {
          operationId: this.operationId,
          operationBilanId: this.operationBilanId,
          simulationId: this.simulationId
        }
      })
    },

  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/views/operation/OperationShowTabs/OperationShowInsurances.vue